import React from 'react';
import CommonInfo from './CommonInfo';
import { getDocumentByFileStoreId } from '@egovernments/digit-ui-libraries/src/utils/fileType';

const basePath = '/digit-ui/citizen';

const infoData = [
  {
    heading: "Forms CheckLists",
    paragraphs: [
      { text: "Internal Procedure For Change Of Land Use Approval", link: "b521d819-007a-412e-8143-edaa57951f66" },
      { text: "Internal Procedure For Building Planning Approval", link: "abf94285-3b1f-460e-bde5-73b60b6e1432" },
      { text: "Inspection Procedure And Checklist of Obtaining Construction Permit", link: "8461e16f-9588-47a3-b47f-8efd82a8be92" },
      { text: "Inspection Procedure And Checklist for Obtaining Final NOC", link: "13822986-edd3-4152-8fc4-4414c3966047" },
      { text: "Procedure And Guidelines For Obtaining Planning Permission on Form12", link: "85661128-d905-4ac9-b4e2-299193597b35" },
    ],
    buttonLabel: "View More >",
    link: `${basePath}/forms-checklists`,
  },
  {
    heading: "Notification/Orders",
    paragraphs: [
      { text: "Circular Mandating Online Submission of Application", link: "90c7d8fc-f4f6-474f-876f-dd84b983dfa9" },
      { text: "Clarification Regarding MIS - Interpreting of Basements", link: "3f467201-8918-4f52-9b15-be8532605b01" },
      { text: "Notice For Publication Of Proposed Amendment(s) In Development Plans", link: "b7b4cfbd-a368-4378-8052-96bd37ed2c2f" },
      { text: "Amendment In Idp Shimla Notification Dated 28/06/2016", link: "bb7cd57d-27b8-42b1-a03d-4488feceaef5" },
      { text: "Exemptions In Rural Areas-clarifications Thereof", link: "7e485345-b50b-4856-bf4d-49ae76d85c57" },
    ],
    buttonLabel: "View More >",
    link: `${basePath}/notifications-under-tcp-act`
  },
  {
    heading: "Development Plans",
    paragraphs: [
      { 
        image: "https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20231201_125157.jpg", 
        text: "Kullu Valley Planning Area",
        link: "a4b14125-e083-4c1d-a313-4abfed428c0a" 
      },
      { 
        image: "https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20230520_125218.jpg", 
        text: "Mehatpur",
        link: "13416074-abe2-4671-8b93-8e3dcf9663e7" 
      },
      { 
        image: "https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20230520_124721.jpg", 
        text: "Hatkoti",
        link: "c0972bbe-7d37-4d84-b20b-f231cd4cd1c6" 
      },
      ],
    buttonLabel: "View More >",
    link: `${basePath}/development-plan`,
  },
];

export default function AppInfo() {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', flexWrap: 'wrap' }}>
      {infoData.map((info, index) => (
        <CommonInfo
          key={index}
          heading={info.heading}
          paragraphs={info.paragraphs}
          buttonLabel={info.buttonLabel}
          link={info.link}
        />
      ))}
    </div>
  );
}
